import { Loading } from '@shopify/polaris';
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import Dashboard from '../home/Dashboard';
import { useLegacyMode } from './LegacyModeContext';

export const ModeHome = () => {
    const { loading, isLegacy } = useLegacyMode();
    if (loading) return <Loading />;
    return isLegacy ? <Navigate replace to="/legacy/settings" /> : <Dashboard />;
};

const LegacyRouteGuard = ({ children }: { children: ReactNode }) => {
    const { loading, isLegacy } = useLegacyMode();
    if (loading) return <Loading />;
    return isLegacy ? <>{children}</> : <Navigate replace to="/dashboard" />;
};

export default LegacyRouteGuard;
